import Typography from 'components/generics/texts/Typography';
import NewTabLink from 'components/next/NewTabLink';
import { PROPERTY_DOCUMENTS } from 'consts/legalDocs';
import { LIQUIDITY_DISCLOSURE_URI } from 'pages/place-order/components/DebtOrderSummary/components/LiquidityDisclosure';
import React from 'react';
import { DebtType } from 'types/debt-types';
import { DocObject } from 'types/legal-documents';
import classes from './index.module.scss';

const SharesLiquidityAnswer = ({ debt }: { debt: DebtType }) => {
  const docs = debt?.documents;

  return (
    <Typography className={classes.container}>
      Lend is a long term investment. Investors may opt to redeem their shares
      after holding them for a minimum of 12 months. The redemption plan enables
      investors to sell their shares at a rate ranging between 97-100% of the
      share price at the time of the redemption request, subject to the duration
      of holdings and redemption maximums. For more information about the
      redemption plan visit our{' '}
      <NewTabLink
        className={classes.link}
        to={LIQUIDITY_DISCLOSURE_URI}
      >
        Help Center
      </NewTabLink>{' '}
      or{' '}
      <NewTabLink
        className={classes.link}
        to={
          docs?.find(
            (doc: DocObject) =>
              doc.title === PROPERTY_DOCUMENTS.OFFERING_CIRCULAR
          )?.uri ?? ''
        }
      >
        Offering Circular
      </NewTabLink>
      .
    </Typography>
  );
};

export default SharesLiquidityAnswer;
